import {coerceToString} from "../../../utils/coerceToString";


export function removeActiveFilter(field, value, activeFilters) {

    // create local copy so as to not mutate original
    let newActiveFilters = [ ...activeFilters ];

    newActiveFilters = newActiveFilters.filter(item => {
        // we need to coerce to string as if this value is coming via a form with e.target.value or
        // similar then it will have been coerced to a string already.
        const itemFieldString = coerceToString(item.field);
        const itemValueString = coerceToString(item.value);
        const fieldString = coerceToString(field);
        const valueString = coerceToString(value);

        return itemFieldString !== fieldString || itemValueString !== valueString;
    });

    return newActiveFilters
}
